import { useTranslation } from "react-i18next";

const LOCALES = [
  { code: "en", label: "EN" },
  { code: "sv", label: "SV" },
];

export function LocaleSwitcher() {
  const { i18n } = useTranslation();
  const current = i18n.resolvedLanguage ?? "en";
  return (
    <div className="flex items-center gap-1 text-xs">
      {LOCALES.map((l) => (
        <button
          key={l.code}
          type="button"
          onClick={() => void i18n.changeLanguage(l.code)}
          className={
            "rounded px-2 py-1 " +
            (current === l.code
              ? "bg-slate-900 text-white"
              : "text-slate-500 hover:text-slate-900")
          }
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
